/* global cookieUtils  */

export default {
  getArrivalDate: function getArrivalDate(startDate, endDate) {
    if (startDate === endDate) {
      return this.formatDate(startDate, true);
    }
    return this.formatDate(startDate, false) + ' - ' + this.formatDate(endDate, false);

  },
  getDeliveryDateAvailability: function getDeliveryDateAvailability(deliveryDateAvailability) {
    let availableDeliveryDate = '';
    if (deliveryDateAvailability && deliveryDateAvailability.toLowerCase()) {
      availableDeliveryDate = deliveryDateAvailability;
    }
    return availableDeliveryDate;
  },
  isDeliveryTimelineTodayOrTomorrow:
    function isDeliveryTimelineTodayOrTomorrow(deliveryDateAvailability) {
      let isDeliveryDateToday = false;
      if (deliveryDateAvailability
        && (deliveryDateAvailability.toLowerCase() === 'today'
          || deliveryDateAvailability.toLowerCase() === 'tomorrow')
      ) {
        isDeliveryDateToday = true;
      }
      return isDeliveryDateToday;
    },
  getBulletPoints: function getBulletPoints(description) {
    let bulletPoints = '';
    if (description) {
      bulletPoints = description.split('||');
    }
    return bulletPoints;
  },
  isBulletPoints: function isBulletPoints(shipMode) {
    let hasBulletPoints = false;
    if (shipMode.hasBulletPoints && shipMode.bulletPoints.length > 0) {
      hasBulletPoints = true;
    }
    return hasBulletPoints;
  },
  hasShipModes: function hasShipModes(data) {
    let isShipModes = false;
    if (data
      && data.items
      && data.items.length > 0
      && data.items[0].deliveries
      && data.items[0].deliveries.length > 0
      && data.items[0].deliveries[0].shipModes
      && data.items[0].deliveries[0].shipModes.length > 0) {
      isShipModes = true;
    }
    return isShipModes;
  },
  formatDate: function formatDate(date, isLongMonthName) {
    if (!date) {
      return date;
    }
    const dateparts = date.split('-');
    const formattedDate = new Date(dateparts[0], dateparts[1] - 1, dateparts[2], 0, 0, 0);
    const longMonthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (isLongMonthName) {
      return longMonthNames[formattedDate.getMonth()] + ' ' + formattedDate.getDate();
    }
    return shortMonthNames[formattedDate.getMonth()] + ' ' + formattedDate.getDate();
  },
  checkAvailabilityResponse: function checkAvaiabilityResponse(response, zipCode) {
    let isCheckAvailabilityResponse = false;
    if (response
      && response.isDeliveryOptionResponse
      && !response.error
      && (zipCode !== response.zipCode)) {
      isCheckAvailabilityResponse = true;
    }
    return isCheckAvailabilityResponse;
  },
  setDETAZip: function setDETAZip(zipCode) {
    if (typeof window !== 'undefined' && window.cookieUtils.fed_CreateCookie) {
      cookieUtils.fed_CreateCookie('DETA_ZIP', zipCode, null);
    }
  },
  getDETAZip: function getDETAZip() {
    return (typeof window !== 'undefined' && window?.cookieUtils?.readBrowserCookie('DETA_ZIP'));
  },
  getDeliveryZip: function getDeliveryZip() {
    let zipCode = '';
    if (typeof window !== 'undefined') {
      const zipDetails = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
      zipCode = zipDetails?.zipcode;
    }
    return zipCode;
  },
  setDeliveryZip: function setDeliveryZip(deliveryZipCode) {
    if (typeof window !== 'undefined' && window?.THD_LOCALIZER_AUTO_INIT?.Localizer && deliveryZipCode) {
      window.THD_LOCALIZER_AUTO_INIT.Localizer.updateDeliveryZipcodeDetails(deliveryZipCode, 'USER');
    }
  }
};